import React from 'react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { Reports } from '../../../../shared/types/reports';
import { ReportStatus } from '../../../../shared/constants/Rerpots';

import noReports from '../../../../assets/icons/no-reports.png';
import reportIcon from '../../../../assets/icons/General/report-icon.svg';
import LoadingIcon from '../../../../assets/icons/loaderDark.gif';
import loader from '../../../../assets/icons/loaderDark.gif';
import downloadIcon from '../../../../assets/icons/General/download-arrow.svg';
import { Typography } from '../../../widgets/Typography';

interface IPastReportsProps {
  pastReportsData: Reports[];
  isLoadingPastReports: boolean;
  handleSubmitDownload: (reportId: string) => void;
  formDisabled: boolean;
  canSelectOrganisations: boolean;
}

function PastReports({
  pastReportsData,
  isLoadingPastReports,
  handleSubmitDownload,
  formDisabled,
  canSelectOrganisations,
}: IPastReportsProps) {
  const { t } = useTranslation();

  return (
    <div
      className={` ${
        canSelectOrganisations ? 'max-h-[700px]' : 'max-h-[597px]'
      } bg-grey-25 w-full max-w-[424px] pt-6 md:p-6 ${
        pastReportsData && pastReportsData.length > 4 && 'lg:!pr-2'
      }`}
    >
      <Typography variant="body-xl" weight="bold" className="mb-2">
        {t('PAST_REPORTS')}
      </Typography>
      <Typography variant="body-sm" className="text-grey-700 mb-5">
        {t('PAST_REPORTS_SUBHEADING')}
      </Typography>
      {isLoadingPastReports ? (
        <div className="grid h-[40%] content-center justify-center">
          <img width="40" src={loader} alt="Loading..." />
        </div>
      ) : pastReportsData.length === 0 ? (
        <div className="grid h-[83%] content-center items-center justify-center text-center">
          <div className="lg:-mt-[140px]">
            <img
              src={noReports}
              className="mx-auto mb-[15px] max-w-[130px]"
              alt="No reorts"
            />
            <p className="text-black-900 text-lg font-semibold">
              {t('NO_REPORTS')}
            </p>
            <p className="text-black-600 text-sm">
              {t('NO_REPORTS_SUBHEADING')}
            </p>
          </div>
        </div>
      ) : (
        <div
          className={`grid max-h-[455px] gap-y-4 overflow-auto lg:max-h-[84%] ${
            pastReportsData.length > 4 && '!pr-4'
          }`}
        >
          {pastReportsData.map((item: any) => (
            <div
              key={item.id}
              className="border-grey-200 flex items-start justify-between rounded-[1.125rem] border bg-white p-4 shadow-[0px_1px_2px_0px_#1018280D]"
            >
              <div className="flex items-start gap-x-2">
                <img src={reportIcon} alt="" />
                <div className="flex flex-col gap-1">
                  <Typography variant="body-sm" weight="semibold">
                    {item.reportType == 'cs_wmd_report' ||
                    item.reportType == 'cs_wmd_reports'
                      ? t('INSIGHTS_REPORT')
                      : t(item.reportType)}{' '}
                  </Typography>
                  <Typography variant="body-xs" className="text-grey-800">
                    {t('GENERATED_ON')}{' '}
                    {format(new Date(item.createdAt), 'MMM d, yyyy hh:mm a')}
                  </Typography>
                  <Typography variant="body-xs" className="text-grey-800">
                    {t('REPORT_FOR')}{' '}
                    {format(new Date(item.parameters.fromDate), 'd.MM.yyyy')} -{' '}
                    {format(new Date(item.parameters.toDate), 'd.MM.yyyy')}
                  </Typography>
                </div>
              </div>
              {item.status != ReportStatus.FAILED && (
                <button
                  type="button"
                  onClick={() => {
                    if (
                      item.status == ReportStatus.DONE &&
                      pastReportsData[0].status !== String(ReportStatus.PENDING)
                    ) {
                      handleSubmitDownload(item.id);
                    }
                  }}
                  disabled={formDisabled || item.status == ReportStatus.PENDING}
                >
                  <img
                    src={` ${
                      item.status == ReportStatus.PENDING
                        ? LoadingIcon
                        : item.status == ReportStatus.DONE && downloadIcon
                    } `}
                    className={`${
                      item.status == ReportStatus.PENDING && 'h-8 w-8'
                    }`}
                    alt=""
                  />
                </button>
              )}
              {item.status == ReportStatus.FAILED ? (
                <Typography
                  variant="body-xs"
                  weight="semibold"
                  className="text-grey-700 text-right"
                >
                  {t('FAILED_TO_GENERATE')}
                </Typography>
              ) : null}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default PastReports;
